var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"body-2",attrs:{"cols":"9"}},[(_vm.title)?_c('p',{staticClass:"title font-weight-medium",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_vm._t("default")],2),_c('v-col',{attrs:{"cols":"3"}},[_c('misc-controller-status')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }